<div class="overlay" [ngClass]="{ 'popup-drawer-half-size' : (width === 'half'),
'popup-drawer-full-size': (width !== 'half')}" *ngIf="openDrawer" (click)="showHideDrawer()"></div>
<div class="popup-drawer" [id]="drawerId" [ngClass]="{ 'open' : openDrawer ,
 'popup-drawer-half-size' : (width === 'half') , 'popup-drawer-full-size': (width !== 'half'), 
 'openDetail' : detailDrawer , 'bankSelection' : bankSelectionDrawer, 'consentDetails': consentDetailsDrawer,
 'openInfo' : infoDrawer}">
    <ng-content></ng-content>
</div>